import { render, staticRenderFns } from "./ed-section-projects.vue?vue&type=template&id=3474ad0c&scoped=true&"
import script from "./ed-section-projects.ts?vue&type=script&lang=ts&"
export * from "./ed-section-projects.ts?vue&type=script&lang=ts&"
import style0 from "./ed-section-projects.scss?vue&type=style&index=0&id=3474ad0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3474ad0c",
  null
  
)

export default component.exports